const steps = [
  {
    n: "01",
    title: "Sign up & verify",
    desc: "Create your RideMate account, verify your phone and ID. One profile for both roles.",
    accent: "text-[#5FA836]",
  },
  {
    n: "02",
    title: "Pick your mode",
    desc: "Heading somewhere? Find a pool. Driving anyway? Post your trip. Switch any time within 10 minutes.",
    accent: "text-[#24303F]",
  },
  {
    n: "03",
    title: "Ride. Earn. Save.",
    desc: "Pay or earn through the app. In-app chat and a five-star rating system keep every ride safe.",
    accent: "text-[#5FA836]",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative py-28 md:py-36 border-t border-[#e5e7eb] bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 reveal">
          <div className="max-w-2xl">
            <span className="font-display text-[11px] uppercase tracking-[0.25em] text-[#5FA836] font-bold">
              How it works
            </span>
            <h2 className="mt-4 font-display text-4xl md:text-6xl font-black tracking-[-0.03em] leading-tight text-[#24303F]">
              Three steps. <span className="text-gray-400">No drama.</span>
            </h2>
          </div>
          <p className="font-body text-gray-600 text-base md:text-lg max-w-md">
            We engineered RideMate to be the simplest pool-and-post app in India.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-5">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`how-step-${i}`}
              className="reveal lift relative rounded-3xl border border-[#e5e7eb] bg-[#F9FAFB] p-8 md:p-10 overflow-hidden"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className={`font-display text-7xl md:text-8xl font-black ${s.accent} opacity-95 leading-none`}>
                {s.n}
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-[#24303F]">
                {s.title}
              </h3>
              <p className="mt-3 font-body text-gray-600 text-[15px] leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
